/** The villages' wanted boards (ADR 0096): the board's window and its lines. */
export const BOUNTIES_EN: Readonly<Record<string, string>> = {
  // ui/bounty-panel.ts
  'Avis de recherche': 'Wanted Board',
  'Tu lis les avis placardés…': 'You read the notices pinned up…',
  '{village} · nouveaux avis dans {time}': '{village} · new notices in {time}',
  'Aucun avis aujourd’hui.': 'No notices today.',
  'Vue près de : {place}': 'Seen near: {place}',
  Prendre: 'Take',
  Toucher: 'Collect',

  // ui/bounty-text.ts
  'Cette prime n’est plus au tableau.': 'This bounty is no longer on the board.',
  'Approche-toi du tableau.': 'Come closer to the board.',
  'Tu n’as pas encore le niveau de cette région.': 'You are not yet the level of this region.',
  'Il faut le niveau {level} pour les primes de cette région.':
    'You need level {level} for this region’s bounties.',
  'Une autre de tes cibles t’attend déjà : abats-la d’abord.':
    'Another of your targets is already waiting for you: slay it first.',
  'La bête ne trouve pas où se montrer : réessaie dans un instant.':
    'The beast finds nowhere to show itself: try again in a moment.',
  'La bête court toujours : abats-la avant de toucher la prime.':
    'The beast is still at large: slay it before collecting the bounty.',
  'Tu as déjà touché cette prime.': 'You already collected this bounty.',
  'À prendre': 'Up for grabs',
  'En chasse : la bête t’attend': 'Hunting: the beast awaits you',
  'Abattue : la prime t’attend': 'Slain: the bounty awaits you',
  Touchée: 'Collected',
  'Prime touchée : {reward}.': 'Bounty collected: {reward}.',
};
